// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IExpressSetupCoverageDto
 */
export interface IExpressSetupCoverageDto {
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupCoverageDto
     */
    code_level: string;
    /**
     * 
     * @type {number}
     * @memberof IExpressSetupCoverageDto
     */
    plan_amount: number;
    /**
     * 
     * @type {number}
     * @memberof IExpressSetupCoverageDto
     */
    member_amount: number;
    /**
     * 
     * @type {number}
     * @memberof IExpressSetupCoverageDto
     */
    embedded_amount: number;
}

/**
 * Check if a given object implements the IExpressSetupCoverageDto interface.
 */
export function instanceOfIExpressSetupCoverageDto(value: object): value is IExpressSetupCoverageDto {
    if (!('code_level' in value) || value['code_level'] === undefined) return false;
    if (!('plan_amount' in value) || value['plan_amount'] === undefined) return false;
    if (!('member_amount' in value) || value['member_amount'] === undefined) return false;
    if (!('embedded_amount' in value) || value['embedded_amount'] === undefined) return false;
    return true;
}

export function IExpressSetupCoverageDtoFromJSON(json: any): IExpressSetupCoverageDto {
    return IExpressSetupCoverageDtoFromJSONTyped(json, false);
}

export function IExpressSetupCoverageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpressSetupCoverageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code_level': json['code_level'],
        'plan_amount': json['plan_amount'],
        'member_amount': json['member_amount'],
        'embedded_amount': json['embedded_amount'],
    };
}

export function IExpressSetupCoverageDtoToJSON(json: any): IExpressSetupCoverageDto {
    return IExpressSetupCoverageDtoToJSONTyped(json, false);
}

export function IExpressSetupCoverageDtoToJSONTyped(value?: IExpressSetupCoverageDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code_level': value['code_level'],
        'plan_amount': value['plan_amount'],
        'member_amount': value['member_amount'],
        'embedded_amount': value['embedded_amount'],
    };
}

